import IEpDownload from '~icons/ep/download'
import IEpConnection from '~icons/ep/connection'
import IEpMessage from '~icons/ep/message'
import IEpUser from '~icons/ep/user'
import IEpHouse from '~icons/ep/house'
import IEpSearch from '~icons/ep/search'
import IEpSwitch from '~icons/ep/switch'
import IEpScissor from '~icons/ep/scissor'
import IEpFilm from '~icons/ep/film'
import IEpNotebook from '~icons/ep/notebook'
import IEpTimer from '~icons/ep/timer'
import IEpUserFilled from '~icons/ep/user-filled'
import IEpSugar from '~icons/ep/sugar'
import IEpLink from '~icons/ep/link'
import IEpArrowRight from '~icons/ep/arrow-right'
import IEpBack from '~icons/ep/back'
import IEpSetting from '~icons/ep/setting'
import IEpView from '~icons/ep/view'
import IEpTickets from '~icons/ep/tickets'
import IEpDocument from '~icons/ep/document'
import IEpDataAnalysis from '~icons/ep/data-analysis'
import IEpCirclePlus from '~icons/ep/circle-plus'
import IEpPromotion from '~icons/ep/promotion'
import IEpTakeawayBox from '~icons/ep/takeaway-box'
import IEpCollectionTag from '~icons/ep/collection-tag'
import IEpGrid from '~icons/ep/grid'
import IEpInfoFilled from '~icons/ep/info-filled'
import IEpMenu from '~icons/ep/menu'
import IEpLock from '~icons/ep/lock'
import IEpReading from '~icons/ep/reading'
import IEPSetup from '~icons/ep/set-up'
import IEGuide from '~icons/ep/guide'
import IEFlag from '~icons/ep/flag'
import IEOrange from '~icons/ep/orange'
import IEDocument from '~icons/ep/document'
import IETrendCharts from '~icons/ep/trend-charts'
import IEDocumentChecked from '~icons/ep/document-checked'

export default {
  ATTACHMENT: IEpDownload,
  PARTICIPANT: IEpConnection,
  MESSAGE: IEpMessage,
  RESPONDENT: IEpUser,
  HOME: IEpHouse,
  SEARCH: IEpSearch,
  STATUS: IEpSwitch,
  FIND_REPLACE: IEpScissor,
  AUDIT: IEpFilm,
  PROJECTS: IEpNotebook,
  RECENT_PROJECTS: IEpTimer,
  RULES: IEPSetup,
  USER: IEpUserFilled,
  COOPERATION: IEpSugar,
  LINK: IEpLink,
  ARROW_RIGHT: IEpArrowRight,
  ARROW_BACK: IEpBack,
  SETTING: IEpSetting,
  VIEW: IEpView,
  TICKET: IEpTickets,
  REPORTS: IEpDocument,
  GRAPH: IEpDataAnalysis,
  NEW: IEpCirclePlus,
  WEBHOOKS: IEpPromotion,
  WEIGHTSET: IEpTakeawayBox,
  TAGS: IEpCollectionTag,
  GRID: IEpGrid,
  INFO_FILLED: IEpInfoFilled,
  ADMIN: IEpMenu,
  ACCESS: IEpLock,
  READING: IEpReading,
  GUIDE: IEGuide,
  FLAG: IEFlag,
  ORANGE: IEOrange,
  DOCUMENT: IEDocument,
  CHART: IETrendCharts,
  APPROVAL: IEDocumentChecked,
}
